'use strict';

import SlideCrousel from "./SlideCrousel";
import PhotoModal from "./PhotoModal";

let slider_elements = document.getElementsByClassName("OrderBlock__slider");
let slider_settings = {list:"Slider__img", wrapper:"", buttons:"OrderBlock__arrow", nav:"", slideUnit:"%", slideDistance:100, element:1, slideInterval:6000};
let sliders = [];
for (let i = 0; i < slider_elements.length; i++) {
	sliders.push(new SlideCrousel(slider_elements[i], slider_settings));
}



PhotoModal.setModalFromClass("Voice__item");


// WEBPACK FOOTER //
// ./assets/js/CustomOrder.js